import { render, staticRenderFns } from "./FormAsiakas.vue?vue&type=template&id=a8fb1c22&scoped=true&"
import script from "./FormAsiakas.vue?vue&type=script&lang=js&"
export * from "./FormAsiakas.vue?vue&type=script&lang=js&"
import style0 from "./FormAsiakas.vue?vue&type=style&index=0&id=a8fb1c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fb1c22",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VCol,VForm,VIcon,VRow,VSelect,VTextField,VTextarea,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8fb1c22')) {
      api.createRecord('a8fb1c22', component.options)
    } else {
      api.reload('a8fb1c22', component.options)
    }
    module.hot.accept("./FormAsiakas.vue?vue&type=template&id=a8fb1c22&scoped=true&", function () {
      api.rerender('a8fb1c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormAsiakas.vue"
export default component.exports